module.exports = __webpack_public_path__ + "img/TN.e23ce212.svg";